import React, {useRef, useState} from "react";
import SoilController from "../../controllers/SoilController";
import {RenderTableStruct, SubmissionPrepareBase} from "../submission/SubmissionPrepareBase";
import PrepareSubmissionSoil from "../../controllers/PrepareSubmissionSoil";
import SubmissionDataResponse from "../../controllers/SubmissionDataResponse";
import {arrayUpdate} from "../../immutableState";
import Lab from "../../controllers/Lab";
import TestType from "../../controllers/TestType";
import {insertAt, split} from "../../array";
import SubmissionTable, {SubmissionPrepareFunctions} from "../itestsoil/SubmissionTable";
import Dialog from "../../components/Dialog";
import SampleDepth from "../../controllers/SampleDepth";


const csvPopulateSoil = {
    "Sample Number": (value: string, row: PrepareSubmissionSoil) => {
        row.sampleNumber = value;
    },
    "Block": (value: string, row: PrepareSubmissionSoil) => {
        row.blockNumber = value;
    },
    "Test": (value: string, row: PrepareSubmissionSoil, data: SubmissionDataResponse<SoilRow>) => {
        const testsGiven = value.toLowerCase().trim();
        const test = data.tests.find(t => testsGiven == t.value.toLowerCase().trim())?.key;
        if (!test) return;
        row.test = test;
    },
};

export type SoilRow = PrepareSubmissionSoil & { selected?: boolean };

function emptySoilRow(): SoilRow {
    return {
        testId: 0,
        testDataId: null,
        submissionId: null,
        blockNumber: "",
        sampleNumber: "",
        notes: "",
        delete: false,
        test: TestType.ItestFarmerSample,
        sampleDepth: SampleDepth.TopSoil,
        agronomist: "",
        farmName: "",
        depot: "",
        clientName: "",
        agent: "",
        appAdded: new Date(),
        rawLab: "",
        optionalTests: [],
    };
}

function allSelectedOrUnselected(farmerRow: SoilRow[]){
    return farmerRow.filter(s => s.selected).length > 0 && farmerRow.length !== farmerRow.filter(s => s.selected).length
}

export default function SubmissionPrepareSoil(props: { dataIds: number[]; close: (saved: boolean) => void }) {
    const submitRef = useRef<SubmissionPrepareFunctions>();
    const [qcMapVisible, setQcMapVisible] = useState(false);

    function renderTable(submissionData: SubmissionDataResponse<SoilRow>, data: SoilRow[][], setData: (newData :SoilRow[][]) => void, setShowUpload : (show: {show: boolean, index: number}) => void): RenderTableStruct {
        function addRow(index: number) {
            const newArray = data.map((c, i) => index !== i ? c : c.concat(emptySoilRow()))
            setData(newArray)
        }

        function openCsvButton(index: number) {
            setShowUpload({show: true, index})
        }
        
        let result = 
        <>
            {data.map((rowArr, index) => (
                <div key={index}>
                    <SubmissionTable index={index} data={submissionData} leafs={rowArr} submitRef={submitRef}
                                     setData={d => {
                                         setData(arrayUpdate(data, index, d))
                                     }}/>

                    <div className='flex justify-between p-1 mb-1 pb-4 border-b border-gray-400'>
                        <div className='flex items-center'>
                            <div className='btn bg-primary-500' onClick={() => addRow(index)}>+</div>
                            <div className='btn bg-primary-500' onClick={() => openCsvButton(index)}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
                                </svg>
                            </div>
                        </div>

                        {allSelectedOrUnselected(rowArr)
                            ? <div className='btn bg-primary' onClick={() => {
                                const part = split(rowArr, d => d.selected ?? false);
                                const mutate = data.map(d => d);
                                mutate.splice(index, 1);
                                insertAt(mutate, index, part.one.map(d => ({...d, selected: false})), part.two);
                                setData(mutate);
                            }}>Split</div>
                            : null
                        }
                    </div>
                </div>
            ))}
        </>;

        return {
            render: result,
            validation: () => submitRef.current?.validate() || false 
        }
    }

    return (
        <div>
            <SubmissionPrepareBase
                labs={[Lab.ManualSoil, Lab.NvirotekSoil, Lab.WaypointSoil]}
                testDataIds={props.dataIds}
                close={props.close}
                prepare={SoilController.prepareSubmission}
                submit={SoilController.submit}
                renderTable={renderTable}
                csvPopulateMap={csvPopulateSoil}
                emptyRow={emptySoilRow}
                // extraButton={
                //     <div className="btn bg-primary" onClick={() => setQcMapVisible(true)}>
                //         QC Map
                //     </div>
                // }
            />
        </div>
    );
}
